var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlant = function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.372 5.641a7.78 7.78 0 0 1-2.255 4.875 7.78 7.78 0 0 1-2.255-4.875A7.8 7.8 0 0 1 12.117.766a7.8 7.8 0 0 1 2.255 4.875m3.109 9.035a7.78 7.78 0 0 1-5.357-.39 7.8 7.8 0 0 1 3.766-3.831 7.78 7.78 0 0 1 5.357.391 7.78 7.78 0 0 1-3.766 3.83m0 7.5a7.78 7.78 0 0 1-5.357-.39 7.8 7.8 0 0 1 3.766-3.831 7.78 7.78 0 0 1 5.357.391 7.78 7.78 0 0 1-3.766 3.83m-10.718-7.5a7.78 7.78 0 0 0 5.357-.39 7.78 7.78 0 0 0-3.765-3.831A7.78 7.78 0 0 0 3 10.846a7.8 7.8 0 0 0 3.763 3.83m0 7.5a7.78 7.78 0 0 0 5.357-.39 7.78 7.78 0 0 0-3.765-3.831A7.78 7.78 0 0 0 3 18.346a7.8 7.8 0 0 0 3.763 3.83m5.356-11.66.008 12.75"
  })));
};
export default SvgPlant;